module.exports = (__parcel__import__("iEeon")).then(() => parcelRequire('jppWD'));